import {
    createAsyncThunk
} from '@reduxjs/toolkit';
import axios from 'axios';
import {
    api
} from '../../helpers/api_helper';
import Log from '../../Services/Log';
import { API_ENDPOINTS } from '../../constants/apiEndPoints';


export const getTransaction = createAsyncThunk('transactions/getAll', async ({ page , limit }, thunkAPI) => {
    try {
        const response = await api.get(`${API_ENDPOINTS.TRANSACTION.GET_ALL}?limit=${limit}&page=${page}`);
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});


// import {
//     createAsyncThunk
// } from '@reduxjs/toolkit';
// import axios from 'axios';
// import {
//     api
// } from '../../helpers/api_helper';
// import Log from '../../Services/Log';
// import { API_ENDPOINTS } from '../../constants/apiEndPoints';


// export const getTransaction = createAsyncThunk('transactions/getAll', async (page , limit , thunkAPI) => {
//     try {
//         const response = await api.get(API_ENDPOINTS.TRANSACTION.GET_ALL);
//         // Log('getTransaction data' , 'info' , response.data)
//         return response.data;
//     } catch (error) {
//         return thunkAPI.rejectWithValue(error.response.data);
//     }
// });
